<template>
  <div class="index" v-wechat-title="title">
    <img class="index_logo" :src="info.logo"/>
    <div class="index_main">
      <div class="main_title">
        <div class="title_left">登录</div>
<!--        <div class="title_right" @click="toUrl">注册<i class="el-icon-caret-right"></i></div>-->
      </div>
      <div class="main_name">
        <div class="name_left">身份证号</div>
        <div class="name_right">
          <el-input clearable v-model="temp.identityCard" placeholder="请使用身份证号码登陆"></el-input>
        </div>
      </div>
      <div class="main_name">
        <div class="name_left">手机号码</div>
        <div class="name_right">
          <el-input clearable v-model="temp.phone" placeholder="请使用注册的手机号码"></el-input>
        </div>
      </div>

      <div class="main_name">
        <div class="name_left">验证码</div>
        <div class="name_code">
          <div class="code_left">
            <el-input clearable v-model="temp.code" placeholder="短信验证码"></el-input>
          </div>
          <div class="code_right">
            <div class="code_right_a" v-show="Verification" @click="handleClick">点击获取验证码</div>
            <div class="code_right_b" v-show="!Verification" type="info"><span>{{timer}}</span>秒后重新获取</div>
          </div>
        </div>
      </div>
      <!--    登录    -->
      <div class="main_regis" @click="handelLogin" v-if="!loading">点击登录</div>
      <div class="main_regis" v-else>登录中...</div>
    </div>
  </div>
</template>

<script>
    import SIdentify from "./components/SIdentify";
    import {SmsCheck, PostSaveByData} from '@/api/new/login'
    import {mapGetters, mapState} from "vuex";
    export default {
        name: "Index",
        components: {
            SIdentify
        },
        inject:['reload'], // 使用 inject 注入 reload 变量
        data() {
            return {
                Verification:true,    //通过v-show控制显示获取还是倒计时
                timer:60,      //定义初始时间为60s
                loading: false,
                info: {},
                title: "登录",
                time: 60,
                temp: {
                    identityCard: '',
                    type: 1,
                    phone:null
                },
            }
        },
        computed:{
            ...mapGetters(['userinfo','inst_id'])
        },
        created() {
            let user = JSON.parse(this.userinfo)
            if(user!==null){
                this.$router.push({path: '/my'})
                return
            }
        },
        methods:{
            handleClick(){
                let temp = this.temp
                if (!(/^1[3456789]\d{9}$/.test(temp.phone))) {
                    this.$notify.error({
                        title: '错误',
                        message: '请输入正确的手机号码！'
                    });
                    return false;
                }
                this.Verification = false;      //点击button改变v-show的状态
                this.toggleStartbtn()
                let auth_timer = setInterval(()=>{  //定时器设置每秒递减
                    this.timer--;        //递减时间
                    if(this.timer<=0){
                        this.Verification = true;    //60s时间结束还原v-show状态并清除定时器
                        this.timer = 60;    //60s时间结束还原v-show状态并清除定时器
                        clearInterval(auth_timer)
                    }
                },1000)
            },
            handelLogin() {
                let that = this;
                if(that.temp.identityCard=='' || that.temp.identityCard==null){
                    that.$notify.warning({
                        title: '警告',
                        message: '请先填写身份证号码！',
                    });
                    return;
                }
                if (that.temp.phone == '' || that.temp.phone == null) {
                    that.$notify.warning({
                        title: '警告',
                        message: '请先输入手机号码',
                    });
                    return;
                }
                if (that.temp.code == '' || that.temp.code == null) {
                    that.$notify.warning({
                        title: '警告',
                        message: '请输入验证码！',
                    });
                    return;
                }
                that.loading = true
                PostSaveByData(that.temp).then(res => {
                    if (res.code !== 20000) {
                        that.$message.error(res.msg);
                        that.loading = false
                        return
                    }
                    if (res.code === 20000) {
                        that.$notify({
                            title: '登录成功',
                            message: res.msg,
                            type: 'success'
                        });
                        that.loading = false
                        that.userinfo = res.data
                        this.$store.dispatch('user/SETUserInfo', JSON.stringify(res.data));//当页面刷新时把缓存数据赋值给vuex
                        localStorage.setItem('userinfo', JSON.stringify(res.data))
                        this.$router.push({path: '/my'})
                    }
                })
            },
            //发送验证码
            toggleStartbtn() {
                let temp = this.temp
                if (!(/^1[3456789]\d{9}$/.test(temp.phone))) {
                    this.$notify.error({
                        title: '错误',
                        message: '请输入正确的手机号码！'
                    });
                    return false;
                } else {
                    SmsCheck(temp).then(res => {
                        if (res.code === 20000) {
                            this.$message({
                                type: 'success',
                                message: res.msg
                            });
                        }
                    })
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
  .index {
    position: fixed;
    overflow: auto;
    height: 100%;
    background: #f7f7f7;
    width: 100%;

    .index_logo {
      margin-left: 20px;
      margin-top: 20px;
      width: 140px;
      height: 30px;
    }

    .index_main {
      z-index: 1;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -190px;
      margin-top: -180px;
      box-sizing: border-box;
      width: 380px;
      height: 365px;
      padding: 30px 30px 40px;
      background: #fff;
      box-shadow: 0 20px 30px 0 rgba(63, 63, 65, .06);
      border-radius: 10px;

      .main_title {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;

        .title_left {
          color: #2589ff;
          font-size: 20px;
        }

        .title_right {
          color: #9797a1;
          font-size: 14px;
          cursor: pointer;
        }
      }

      .main_name {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #eee;
        margin-top: 15px;

        .name_left {
          color: #595961;
          font-size: 14px;
        }

        .name_right {
          width: 250px;

          /deep/ .el-input__inner {
            border: 1px solid #fff;
          }
        }

        .name_code {
          width: 250px;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;

          .code_left {
            width: 120px;
          }
          .code_right{
            .code_right_a{
              width: 120px;
              text-align: center;
              height: 30px;
              line-height: 30px;
              background-color: #409eff;
              color: #fff;
              font-size: 12px;
              border-radius: 4px;
              cursor: pointer;
              &:hover{
                opacity: 0.8;
              }
            }
            .code_right_b{
              width: 120px;
              text-align: center;
              height: 30px;
              line-height: 30px;
              background-color: #c0c4cc;
              color: #fff;
              font-size: 12px;
              border-radius: 4px;
            }
          }

          /*.code_right {*/
          /*  text-align: center;*/
          /*  cursor: pointer;*/

          /*  .colors {*/
          /*    color: #2589ff;*/
          /*    font-size: 14px;*/
          /*    cursor: pointer;*/
          /*  }*/

          /*  .colors.active {*/
          /*    color: #333;*/
          /*  }*/
          /*}*/

          /deep/ .el-input__inner {
            border: 1px solid #fff;
          }
        }
      }

      .main_regis {
        margin-top: 50px;
        width: 320px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        color: #fff;
        border-radius: 6px;
        font-size: 16px;
        background-color: #2e8cfb;
        cursor: pointer;

        &:hover {
          background-color: #297ee2;
        }
      }

      .main_hint {
        font-size: 12px;
        text-align: center;
        margin-top: 24px;
        color: #b2adbc;
      }
    }
  }
</style>
